// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"pagination_ko-KR__pyqR6","impressionTrackingContainer":"pagination_impressionTrackingContainer__mC5mx","pagination":"pagination_pagination__KrWss"};